import { render, staticRenderFns } from "./ButtonDefault.vue?vue&type=template&id=250abfb2&scoped=true&"
import script from "./ButtonDefault.vue?vue&type=script&lang=js&"
export * from "./ButtonDefault.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDefault.vue?vue&type=style&index=0&id=250abfb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250abfb2",
  null
  
)

export default component.exports